export default "__VITE_ASSET__BWzCnQtZ__"